export default __webpack_public_path__ + "static/media/clock_upcoming_app_time.69baa555.svg";